import React, { useState } from "react";
import { toggle } from "../../../util/common";
import { WalletItemCustomerRewardCard } from "../../../store/common";
import { DialogComponent } from "../../common/DialogComponent";
import ConfirmDeleteWalletDialog from "../../Dialogs/lostWallet/ConfirmDeleteWalletDialog";
import CustomerRewardsCardDialog from "../../Dialogs/lostWallet/CustomerRewardsCardDialog";
import { useTranslation } from "react-i18next";
const CustomerRewardsCard: React.FunctionComponent<{ requestDataCallback(): void; walletItemCustomerRewardCards: WalletItemCustomerRewardCard[] }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [deleteWalletDialogIsVisible, setDeleteWalletDialogIsVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [rewardCardDialogIsVisible, setRewardCardDialogIsVisible] = useState(false);
    const [rewardCardNumber, setRewardCardNumber]: any = useState([]);
    const showDeleteWalletDialog = (selectedItem: WalletItemCustomerRewardCard): any => {
        setSelectedItem(selectedItem);
        setDeleteWalletDialogIsVisible(true);
    };

    const closeDeleteWalletDialog = (): any => {
        setDeleteWalletDialogIsVisible(false);
    };

    const showRewardCardDialog = (selectedItem: WalletItemCustomerRewardCard): any => {
        setSelectedItem(selectedItem);
        setRewardCardDialogIsVisible(true);
    };

    const closeRewardCardDialog = (): any => {
        setRewardCardDialogIsVisible(false);
    };
   const toggleCardNumVisibility =(rewardCard:any) =>{
    if (rewardCardNumber.length > 0) {
        const index = rewardCardNumber.findIndex((element: any) => element.cardNumber ===   rewardCard.cardNumber);
     if (index >= 0) {
        rewardCardNumber.splice(index, 1);
        setRewardCardNumber([...rewardCardNumber]);
    } 
     else {
        setRewardCardNumber([...rewardCardNumber, rewardCard]);
     }
      } else {
        setRewardCardNumber([...rewardCardNumber , rewardCard]);
     }
   }
    return (
        <React.Fragment>
            {props.walletItemCustomerRewardCards &&
                props.walletItemCustomerRewardCards.map((rewardCard: WalletItemCustomerRewardCard, index) => (
                    <div className="data-row" key={"reward-card-" + index}>
                        <div className="link-item">
                            <button
                                type="button"
                                aria-expanded="false"
                                className="link-button"
                                id={"reward-card-" + index}
                                onClick={() => toggle(`reward-card-${index}-details`, `reward-card-${index}`)}
                            >
                                <span className="row link-item">
                                    <span className="col-xs col-no-gutter link-text">
                                        <span className="link-title">
                                            <span className="sr-only btn-toggle-status">Show</span> {rewardCard.cardName}
                                        </span>
                                        <span className="link-helper">
                                            <span className="sr-only">Item Type: </span>
                                            {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.title2")}
                                        </span>
                                    </span>
                                </span>
                            </button>

                            <div className="wallet-details" id={"reward-card-" + index + "-details"} style={{ display: "none" }}>
                                <div
                                    role="grid"
                                    className="data-grid row-height-xs"
                                    id={"reward-card-" + index + "-title"}
                                    aria-labelledby={"reward-card-" + index + "-title"}
                                >
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"reward-card-" + index + "-card-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.cardName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"reward-card-" + index + "-card-name"}>
                                                {rewardCard.cardName} 
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"reward-card-" + index + "-card-number"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.cardNumber")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"reward-card-" + index + "-card-number"}>
                                            {rewardCard &&
                                              rewardCard.cardNumber &&  rewardCardNumber.findIndex((element: any) => element.cardNumber === rewardCard.cardNumber) < 0 ?
                                                      `${"X".repeat(rewardCard.cardNumber.substr(0, rewardCard.cardNumber.length - 4).length)}${rewardCard.cardNumber.substr(
                                                        rewardCard.cardNumber.length - 4
                                                      )}`: rewardCard.cardNumber }
  <button
                                                type="button"
                                                className="btn-default btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                   toggleCardNumVisibility(rewardCard);
                                                }}
                                                title={"Show CardNumber Text"}
                                                style={{marginLeft: '1.25rem'}}
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={`las ${
                                                            rewardCardNumber.findIndex((element: any) => element.cardNumber === rewardCard.cardNumber) < 0 ? "la-eye" : "la-eye-slash"
                                                        }`}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">Show / Hide CardNumber Text</span>
                                            </button>
                                        


                                                      
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"reward-card-" + index + "-full-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.cardHolderFullName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"reward-card-" + index + "-full-name"}>
                                                {rewardCard.cardHolderName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"reward-card-" + index + "-pin"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.pin")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"reward-card-" + index + "-pin"}>
                                                {rewardCard.pin}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"reward-card-" + index + "-phone"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.customerServicePhone")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"reward-card-" + index + "-phone"}>
                                              {rewardCard.customerServicePhoneNumber}   
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"reward-card-" + index + "-website"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.website")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"reward-card-" + index + "-website"}>
                                                {rewardCard.webSite}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"reward-card-" + index + "-notes"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.notes")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"reward-card-" + index + "-notes"}>
                                                {rewardCard.notes}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row between-xs margin-top-l">
                                    <div className="col-xs flex-grow-null col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <ul className="list-reset list-inline">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-red-outline btn-no-border"
                                                    onClick={() => showDeleteWalletDialog(rewardCard)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.deleteButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                            <li className="margin-left-xs">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary-outline"
                                                    id="edit-credit-card-1"
                                                    onClick={() => showRewardCardDialog(rewardCard)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-edit-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.editDetailsButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Delete modal*/}
            {deleteWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-delete-reward-card-wallet" title="Delete Wallet" closeDialog={closeDeleteWalletDialog}>
                    <ConfirmDeleteWalletDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDeleteWalletDialog}
                        walletItem={selectedItem}
                        itemType="reward-card"
                    />
                </DialogComponent>
            )}

            {/* Edit modal*/}
            {rewardCardDialogIsVisible && (
                <DialogComponent dialogId="dialog-edit-reward-card-wallet" title="Edit Reward Card Wallet" closeDialog={closeRewardCardDialog}>
                    <CustomerRewardsCardDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeRewardCardDialog}
                        walletItem={selectedItem}
                        isNew={false}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default CustomerRewardsCard;
